import Jackpots from "@shared/components/Jackpots/Jackpots";
import AllGames from "@shared/components/Сatalog/AllGames";
import { useIsJackpotsShown } from "@shared/hooks/games/game-providers";
import { useIsAuth } from "@shared/hooks/user";
import { useBannersItems } from "@shared/modules/slider/api/banners";
import React, { memo } from "react";

import Sections from "../../components/Navigation/Sections";
import Tags from "../../components/Navigation/Tags";
import CatalogGames from "../../components/Сatalog/CatalogGames";

import { Slider } from "./Slider/Slider";

export const HomeLayout = memo(() => {
  const isAuth = useIsAuth();
  const isJackpotsShown = useIsJackpotsShown();
  const banners = useBannersItems();

  return (
    <>
      <div className="lobby">
        <div className="lobby__inner">
          {banners?.length > 0 ? (
            <Slider auth={isAuth} />
          ) : (
            <div
              style={{
                width: "100%",
                height: isAuth && isJackpotsShown ? 80 : 10,
              }}
            ></div>
          )}

          {isAuth && isJackpotsShown && <Jackpots />}

          <div className="lobby__sticky">
            <div className="lobby__sticky-inner">
              <Sections />

              <Tags />
            </div>
          </div>

          <CatalogGames auth={isAuth} />

          <AllGames auth={isAuth} />
        </div>
      </div>
    </>
  );
});

HomeLayout.displayName = "HomeLayout";
